import React, { Component } from "react";
import { TYPING_TIMEOUT } from "../../constants";
import CustomizedTextField from "./CustomizedTextField";
import { clone } from '../../utils'

class TextFieldWithTypingTimeout extends Component {

    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
            typingTimeout: TYPING_TIMEOUT,
            typedJustNow: false
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let state = { ...prevState };

        let currentValue = nextProps.value;
        if (!prevState.typedJustNow && currentValue !== state.value) {
            state.value = currentValue;
        }

        return state;
    }

    onTextChange(e) {
        if (this.state.fieldTimeout) {
            clearTimeout(this.state.fieldTimeout);
        }

        this.setState({
            typedJustNow: true,
            value: e.target.value,
            fieldTimeout: setTimeout(() => {
                this.validateChanges();
                this.setState({ typedJustNow: false })
            }, this.state.typingTimeout),
        });
    }

    validateChanges() {
        this.props.onValueChange(this.state.value);
    }

    onBlur() {
        if (this.state.fieldTimeout) {
            this.validateChanges();
            this.setState({ typedJustNow: false })
            clearTimeout(this.state.fieldTimeout);
        }
    }

    render() {
        let properties = clone(this.props);
        delete properties.onValueChange;

        return (
            <CustomizedTextField
                {...properties}
                value={this.state.value}
                onBlur={this.onBlur.bind(this)}
                onChange={this.onTextChange.bind(this)}
            />
        );
    }
}

export default TextFieldWithTypingTimeout;
